import {Component, inject} from '@angular/core';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {TranslatePipe} from '@ngx-translate/core';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {TabDeviceListComponent} from '../../components/tab-device-list/tab-device-list.component';
import {Store} from '@ngrx/store';
import {selectIsDevicesLoading} from '../../state/device.selectors';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'app-page-device-list',
  imports: [
    CardComponent,
    AsyncPipe,
    // MatTabGroup,
    // MatTab,
    // TranslatePipe,
    TabDeviceListComponent,
    // TabAreaListComponent
  ],
  templateUrl: './page-device-list.component.html',
  styleUrl: './page-device-list.component.scss'
})
export class PageDeviceListComponent {
  private store = inject(Store);

  loading$ = this.store.select(selectIsDevicesLoading);
}
